<template>
  <base-message :message="message">
    <div class="test-message">
      <label><b class="is-text-rsmall is-text-info">{{ message.data.title }}</b></label>
      <ol>
        <li :key="index" v-for="(test,index) in message.data.tests">
          <div>
            <!--测试要求-->
            <p v-html="test.desc"></p>
            <!--错误信息-->
            <p :class="message.data.results[index].success ? 'is-text-success' : 'is-text-error'"
               v-if="message.data.results[index]">
              {{ message.data.results[index].message }}
            </p>
          </div>
        </li>
      </ol>
      <br>
      <div>
        <div class="buttons one-line">
          <a @click="detect"
             class="button is-link is-small">检查是否完成</a>
          <a @click="skip"
             class="button is-link is-small">跳过练习</a>
        </div>
      </div>
    </div>
  </base-message>
</template>

<script>
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import { TestMessage, TestStatus, TestType } from '@/components/classroom/lib/Message'
import { JupyterChecker } from '@/components/classroom/lib/tests/JupyterChecker'

export default {
  props: ['message'],
  components: { BaseMessage },
  data () {
    return {
      TestMessageType: TestType,
      IClassroom: IClassroom,
      TestMessage: TestMessage
    }
  },
  methods: {
    async skip () {
      this.message.data.status = TestStatus.SKIP
      await this.IClassroom.requestNextMessage()
    },
    async detect () {
      this.message.data.results = []
      this.message.data.status = TestStatus.PENDING
      let pass = true
      for (let i = 0; i < this.message.data.tests.length; i++) {
        const result = await this.runTest(this.message.data.tests[i])
        this.message.data.results.push(result)
        if (!result.success) {
          result.message = result.message || this.message.data.tests[i].fail || '未完成'
          this.message.data.status = TestStatus.ERROR
          pass = false
        } else {
          result.message = this.message.data.tests[i].success || '已完成'
        }
      }
      if (pass) {
        this.message.data.status = TestStatus.PASS
        await this.IClassroom.requestNextMessage(1000)
      }
    },
    async runTest (testCase) {
      if (testCase.type === TestType.JUPYTER) {
        let content = await IClassroom.getWorkspaceFile(testCase.params.filename)
        if (!content) {
          return {
            success: false,
            message: '未下载文件！'
          }
        }
        content = JSON.parse(content)
        return JupyterChecker.check(content, testCase.params.expects || [])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.test-message {
  padding .75em
  min-width 200px

  ol {
    margin-left 1.5rem
    margin-top .5rem
  }
}
</style>
